import PaymentDetail from './PaymentDetail';

export default PaymentDetail;
